import getInitialUserState from './state';
import Cookies from 'js-cookie';
import qoalaStorage from '~/core/Storage';

export default {
  updateData(state, value) {
    state.userToken = value.token;
    state.userTokenRefresh = value.refresh;
    state.userData = value.user;

    Cookies.set('t', state.userToken, { expires: 2 });
    Cookies.set('r', state.userTokenRefresh, { expires: 2 });
  },
  updateRefreshToken(state, value) {
    state.callRefreshToken = value;
  },
  updateDataUser(state, user) {
    state.userData = user;
    qoalaStorage.setItem('u', JSON.stringify(state.userData));
  },
  updateDataPosition(state, position) {
    state.userPosition = position;
    qoalaStorage.setItem('position', JSON.stringify(state.userPosition));
  },
  updateNotifications(state, notification) {
    state.userNotif = notification;
    qoalaStorage.setItem('n', JSON.stringify(state.userNotif));
  },
  updateNotificationsList(state, notification) {
    state.userNotifs = notification;
    qoalaStorage.setItem('l', JSON.stringify(state.userNotifs));
  },
  /*eslint-disable*/
  clearState(state) {
    state = getInitialUserState();
  },
  updateUserUnread(state, status) {
    state.userUnread = status;
  },
  clearRefreshToken(state) {
    clearTimeout(state.callRefreshToken);
    state.callRefreshToken = null;
  },
  removeToken(state) {
    state.userToken = null;
    state.userTokenRefresh = null;
    state.userData = null;
    state.userPosition = null;
    qoalaStorage.clear();
    Cookies.remove('t');
    Cookies.remove('r');
    this.commit('general/updateFirstTime', false);
    this.commit('general/updateCalledOnce', false);
    this.$axios.setToken(false);
  },
  temporaryRegister(state, register) {
    state.tempRegister = register;
    qoalaStorage.setItem('tempReg', JSON.stringify(state.tempRegister));
  }
};
